// extracted by mini-css-extract-plugin
export default {"control":"Control_control__sWuv+","button":"Control_button__2I9RT"};